import type { SxProps, Theme } from '@mui/material'

export const popupInputLabelSx = {
	fontFamily: 'Poppins, sans-serif',
	fontSize: '11px',
	fontWeight: 400,
	lineHeight: '12px',
	letterSpacing: '0.15px',
	color: 'var(--primary-dark)',
	backgroundColor: '#FFFFFF',
	padding: '0 4px',
	transform: 'translate(12px, -6px) scale(1)',
	transformOrigin: 'top left',
} as const

export const calendarInputSx = {
	'& .MuiInputBase-root': {
		cursor: 'pointer',
	},
	'& .MuiInputBase-input': {
		cursor: 'pointer',
	},
	'& .MuiOutlinedInput-root': {
		cursor: 'pointer',
	},
	'& .MuiOutlinedInput-input': {
		cursor: 'pointer',
	},
	'& .MuiInputAdornment-root': {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: '100%',
		margin: 0,
		maxHeight: 'none',
		pointerEvents: 'none',
	},
	'& .MuiInputAdornment-root .MuiButtonBase-root': {
		width: '100%',
		height: '100%',
		margin: 0,
		padding: 0,
		minWidth: 'unset',
		pointerEvents: 'auto',
		cursor: 'pointer',
	},
	'& .MuiInputAdornment-root .MuiSvgIcon-root': {
		display: 'none',
	},
} satisfies SxProps<Theme>

export const calendarPopperSx = {
	zIndex: 2100,
} satisfies SxProps<Theme>

export const calendarPopperSlotProps = {
	popper: { sx: calendarPopperSx },
	desktopPaper: { sx: calendarPopperSx },
} as const
